var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "session-message-dialog",
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.dialogVisible,
        width: "80%",
        "before-close": _vm.handleClose,
        "modal-append-to-body": false,
        "append-to-body": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _vm.sessionData
        ? _c(
            "div",
            { staticClass: "session-info" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("label", [_vm._v("会话ID：")]),
                      _c("span", [_vm._v(_vm._s(_vm.sessionData.sessionId))]),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("label", [_vm._v("会话标题：")]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.sessionData.title || "无标题")),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "message-list" },
        [
          _c("avue-crud", {
            ref: "messageCrud",
            attrs: {
              option: _vm.messageOption,
              "table-loading": _vm.loading,
              data: _vm.messageData,
              page: _vm.page,
            },
            on: {
              "current-change": _vm.currentChange,
              "size-change": _vm.sizeChange,
              "refresh-change": _vm.refreshChange,
              "on-load": _vm.onLoad,
            },
            scopedSlots: _vm._u([
              {
                key: "menu",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          size: "small",
                          icon: "el-icon-s-order",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handleViewTasks(scope.row)
                          },
                        },
                      },
                      [_vm._v("\n          查看任务\n        ")]
                    ),
                  ]
                },
              },
              {
                key: "msgType",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getMsgTypeColor(scope.row.msgType),
                          size: "small",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.getMsgTypeText(scope.row.msgType)) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "content",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "message-content" },
                      [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: scope.row.content,
                              placement: "top",
                              disabled:
                                !scope.row.content ||
                                scope.row.content.length <= 50,
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.truncateText(scope.row.content, 50))
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [_c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("关闭")])],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }